interface ExcludedFromBudgetBadgeProps {
  excluded: boolean;
}

export function ExcludedFromBudgetBadge({
  excluded,
}: ExcludedFromBudgetBadgeProps) {
  if (!excluded) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded bg-amber-100 text-amber-700 text-xs"
      title="Esta transacción no se incluye en el presupuesto"
    >
      Excluido del presupuesto
    </span>
  );
}
